import { gsap } from "gsap";
import LocomotiveScroll from 'locomotive-scroll';
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
// Import Highway
import Highway from '@dogstudio/highway';


gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,EaselPlugin);

// For Live Projects
window.addEventListener('load',function(){
  document.querySelector('body').classList.add("loaded")  
});



const lenis = new Lenis({
  lerp:0.07,
  duration:1.2,

});

lenis.on('scroll', (e) => {
  console.log(e)
})

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

document.addEventListener('DOMContentLoaded', function () {
            const toggleButton = document.querySelector('.toggle button');
            const container = document.querySelector('.container');
            const links = document.querySelectorAll('.link');
            let isOpen = false;

            const timeline = gsap.timeline({ paused: true });

            timeline.to(container, {
                duration: 1,
                ease: "power3.inOut",
                clipPath: 'polygon(0 0, 0 100%, 100% 100%, 100% 0)',
            });

            timeline.to(links, {
                duration: 1,
                top: 0,
                opacity: 1,
                stagger: 0.05,
                ease: "power3.inOut",
            }, "-=1"); 

            toggleButton.addEventListener('click', function() {
                if (isOpen) {
                    timeline.reverse();
                } else {
                    timeline.play();
                }
            isOpen = !isOpen;
            });
        });

gsap.from(".phat1", {
    duration: 1.8,
    opacity:0,
    stagger:0.2,
    y: 30,
    ease: "sine.inOut"
});


const hero = gsap.timeline({
  scrollTrigger:{
    scrub:1,
    trigger:"#phat-panda-hero",
    start:"top top",
    end:"bottom 50%",
  },
});

hero.to(".hero-title",{opacity:0,y:200});


const resin = gsap.timeline({
  scrollTrigger:{
    scrub:2,
    pin:true,
    ease:"none",
    trigger:"#fullspec-story",
    start:"top top",
    end:"+=1000",
  },
});

resin.from("#fullspec-story",{opacity:0,duration:2});
resin.from(".block-lr",{opacity:0, y:100, stagger:0.2, duration:2});
resin.from(".block-lr-2",{opacity:0, y:100,duration:2});
resin.to(".lr-wrapper",{opacity:0, y:100,duration:2});
resin.from(".block-video",{opacity:0,duration:2});
resin.to(".block-video",{duration:2});

const resin3 = gsap.timeline({
  scrollTrigger:{
    pin:true,
    scrub:3,
    trigger:"#lr-section-03",
    start:"top top",
    end:"+=3000",
  },
});

resin3.from("#lr-section-03",{opacity:0,duration:2}, 0);
resin3.from(".lr-img-2",{opacity:0, y:100, ease:"none",duration:2});
resin3.to("#lr-section-03",{opacity:0, duration:1, ease:"none",duration:2});